import React from 'react'
import './InfoBar.css'

function index() {
    return (
        <div className="infobar">
            <div className="infobar_card">
                <h1>2+</h1>
                <p>years of experience</p>
            </div>
            <div className="infobar_card">
                <h1>145+</h1>
                <p>companies around the world</p>
            </div>
            <div className="infobar_card">
                <h1>24</h1>
                <p>places to visit</p>
            </div>
            <div className="infobar_card">
                <h1>13</h1>
                <p>types of services</p>
            </div>
        </div>
    )
}

export default index
